// extracted by mini-css-extract-plugin
export default {"viewBtn":"PrintLink_viewBtn__jr0EB","spin":"PrintLink_spin__e3oc4"};